import { ChevronRight } from 'lucide-react'

import type { Breadcrumb } from '@/types/shared'
import { cn } from '@/lib/cn'

type BreadcrumbsProps = {
  items: Breadcrumb[]
  className?: string
}

export function Breadcrumbs({ items, className }: BreadcrumbsProps) {
  if (!items || items.length === 0) {
    return null
  }

  return (
    <nav className={cn('flex items-center gap-2 text-sm text-slate-400', className)} aria-label="breadcrumb">
      {items.map((item, index) => {
        const isLast = index === items.length - 1
        return (
          <span key={`${item.label}-${index}`} className="flex items-center gap-2">
            {item.href && !isLast ? (
              <a
                href={item.href}
                className="rounded-full border border-transparent px-3 py-1 transition hover:border-white/10 hover:bg-white/10 hover:text-white"
              >
                {item.label}
              </a>
            ) : (
              <span className="px-3 py-1 text-white/70">{item.label}</span>
            )}
            {!isLast ? <ChevronRight className="h-4 w-4 text-white/30" /> : null}
          </span>
        )
      })}
    </nav>
  )
}
